export const getIsClient = () => import.meta.client

export const getIsDev = () => import.meta.dev

export const getIsServer = () => import.meta.server
